/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createNote = /* GraphQL */ `mutation CreateNote(
  $input: CreateNoteInput!
  $condition: ModelNoteConditionInput
) {
  createNote(input: $input, condition: $condition) {
    id
    title
    trip {
      id
      owner
      tripName
      destination
      startDate
      endDate
      tripImageUrl
      tripImageKey
      notes {
        items {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      profile {
        id
        owner
        username
        followers
        following
        profilePicture {
          original
          small
          medium
          large
          __typename
        }
        trips {
          nextToken
          startedAt
          __typename
        }
        email
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      profileTripsId
      __typename
    }
    note
    owner
    coords {
      lat
      long
      __typename
    }
    locationName
    createdAt
    images
    tags {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    tripNotesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNoteMutationVariables,
  APITypes.CreateNoteMutation
>;
export const updateNote = /* GraphQL */ `mutation UpdateNote(
  $input: UpdateNoteInput!
  $condition: ModelNoteConditionInput
) {
  updateNote(input: $input, condition: $condition) {
    id
    title
    trip {
      id
      owner
      tripName
      destination
      startDate
      endDate
      tripImageUrl
      tripImageKey
      notes {
        items {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      profile {
        id
        owner
        username
        followers
        following
        profilePicture {
          original
          small
          medium
          large
          __typename
        }
        trips {
          nextToken
          startedAt
          __typename
        }
        email
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      profileTripsId
      __typename
    }
    note
    owner
    coords {
      lat
      long
      __typename
    }
    locationName
    createdAt
    images
    tags {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    tripNotesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNoteMutationVariables,
  APITypes.UpdateNoteMutation
>;
export const deleteNote = /* GraphQL */ `mutation DeleteNote(
  $input: DeleteNoteInput!
  $condition: ModelNoteConditionInput
) {
  deleteNote(input: $input, condition: $condition) {
    id
    title
    trip {
      id
      owner
      tripName
      destination
      startDate
      endDate
      tripImageUrl
      tripImageKey
      notes {
        items {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      profile {
        id
        owner
        username
        followers
        following
        profilePicture {
          original
          small
          medium
          large
          __typename
        }
        trips {
          nextToken
          startedAt
          __typename
        }
        email
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      profileTripsId
      __typename
    }
    note
    owner
    coords {
      lat
      long
      __typename
    }
    locationName
    createdAt
    images
    tags {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    updatedAt
    _version
    _deleted
    _lastChangedAt
    tripNotesId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNoteMutationVariables,
  APITypes.DeleteNoteMutation
>;
export const createTag = /* GraphQL */ `mutation CreateTag(
  $input: CreateTagInput!
  $condition: ModelTagConditionInput
) {
  createTag(input: $input, condition: $condition) {
    id
    label
    notes {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTagMutationVariables,
  APITypes.CreateTagMutation
>;
export const updateTag = /* GraphQL */ `mutation UpdateTag(
  $input: UpdateTagInput!
  $condition: ModelTagConditionInput
) {
  updateTag(input: $input, condition: $condition) {
    id
    label
    notes {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTagMutationVariables,
  APITypes.UpdateTagMutation
>;
export const deleteTag = /* GraphQL */ `mutation DeleteTag(
  $input: DeleteTagInput!
  $condition: ModelTagConditionInput
) {
  deleteTag(input: $input, condition: $condition) {
    id
    label
    notes {
      items {
        id
        noteID
        tagID
        note {
          id
          title
          note
          owner
          locationName
          createdAt
          images
          updatedAt
          _version
          _deleted
          _lastChangedAt
          tripNotesId
          __typename
        }
        tag {
          id
          label
          owner
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        owner
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTagMutationVariables,
  APITypes.DeleteTagMutation
>;
export const createTrip = /* GraphQL */ `mutation CreateTrip(
  $input: CreateTripInput!
  $condition: ModelTripConditionInput
) {
  createTrip(input: $input, condition: $condition) {
    id
    owner
    tripName
    destination
    startDate
    endDate
    tripImageUrl
    tripImageKey
    notes {
      items {
        id
        title
        trip {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        note
        owner
        coords {
          lat
          long
          __typename
        }
        locationName
        createdAt
        images
        tags {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        tripNotesId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    profile {
      id
      owner
      username
      followers
      following
      profilePicture {
        original
        small
        medium
        large
        __typename
      }
      trips {
        items {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    profileTripsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTripMutationVariables,
  APITypes.CreateTripMutation
>;
export const updateTrip = /* GraphQL */ `mutation UpdateTrip(
  $input: UpdateTripInput!
  $condition: ModelTripConditionInput
) {
  updateTrip(input: $input, condition: $condition) {
    id
    owner
    tripName
    destination
    startDate
    endDate
    tripImageUrl
    tripImageKey
    notes {
      items {
        id
        title
        trip {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        note
        owner
        coords {
          lat
          long
          __typename
        }
        locationName
        createdAt
        images
        tags {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        tripNotesId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    profile {
      id
      owner
      username
      followers
      following
      profilePicture {
        original
        small
        medium
        large
        __typename
      }
      trips {
        items {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    profileTripsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTripMutationVariables,
  APITypes.UpdateTripMutation
>;
export const deleteTrip = /* GraphQL */ `mutation DeleteTrip(
  $input: DeleteTripInput!
  $condition: ModelTripConditionInput
) {
  deleteTrip(input: $input, condition: $condition) {
    id
    owner
    tripName
    destination
    startDate
    endDate
    tripImageUrl
    tripImageKey
    notes {
      items {
        id
        title
        trip {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        note
        owner
        coords {
          lat
          long
          __typename
        }
        locationName
        createdAt
        images
        tags {
          nextToken
          startedAt
          __typename
        }
        updatedAt
        _version
        _deleted
        _lastChangedAt
        tripNotesId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    profile {
      id
      owner
      username
      followers
      following
      profilePicture {
        original
        small
        medium
        large
        __typename
      }
      trips {
        items {
          id
          owner
          tripName
          destination
          startDate
          endDate
          tripImageUrl
          tripImageKey
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          profileTripsId
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      email
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    profileTripsId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTripMutationVariables,
  APITypes.DeleteTripMutation
>;
export const createProfile = /* GraphQL */ `mutation CreateProfile(
  $input: CreateProfileInput!
  $condition: ModelProfileConditionInput
) {
  createProfile(input: $input, condition: $condition) {
    id
    owner
    username
    followers
    following
    profilePicture {
      original
      small
      medium
      large
      __typename
    }
    trips {
      items {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateProfileMutationVariables,
  APITypes.CreateProfileMutation
>;
export const updateProfile = /* GraphQL */ `mutation UpdateProfile(
  $input: UpdateProfileInput!
  $condition: ModelProfileConditionInput
) {
  updateProfile(input: $input, condition: $condition) {
    id
    owner
    username
    followers
    following
    profilePicture {
      original
      small
      medium
      large
      __typename
    }
    trips {
      items {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateProfileMutationVariables,
  APITypes.UpdateProfileMutation
>;
export const deleteProfile = /* GraphQL */ `mutation DeleteProfile(
  $input: DeleteProfileInput!
  $condition: ModelProfileConditionInput
) {
  deleteProfile(input: $input, condition: $condition) {
    id
    owner
    username
    followers
    following
    profilePicture {
      original
      small
      medium
      large
      __typename
    }
    trips {
      items {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    email
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteProfileMutationVariables,
  APITypes.DeleteProfileMutation
>;
export const createNoteTags = /* GraphQL */ `mutation CreateNoteTags(
  $input: CreateNoteTagsInput!
  $condition: ModelNoteTagsConditionInput
) {
  createNoteTags(input: $input, condition: $condition) {
    id
    noteID
    tagID
    note {
      id
      title
      trip {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      note
      owner
      coords {
        lat
        long
        __typename
      }
      locationName
      createdAt
      images
      tags {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tripNotesId
      __typename
    }
    tag {
      id
      label
      notes {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNoteTagsMutationVariables,
  APITypes.CreateNoteTagsMutation
>;
export const updateNoteTags = /* GraphQL */ `mutation UpdateNoteTags(
  $input: UpdateNoteTagsInput!
  $condition: ModelNoteTagsConditionInput
) {
  updateNoteTags(input: $input, condition: $condition) {
    id
    noteID
    tagID
    note {
      id
      title
      trip {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      note
      owner
      coords {
        lat
        long
        __typename
      }
      locationName
      createdAt
      images
      tags {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tripNotesId
      __typename
    }
    tag {
      id
      label
      notes {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateNoteTagsMutationVariables,
  APITypes.UpdateNoteTagsMutation
>;
export const deleteNoteTags = /* GraphQL */ `mutation DeleteNoteTags(
  $input: DeleteNoteTagsInput!
  $condition: ModelNoteTagsConditionInput
) {
  deleteNoteTags(input: $input, condition: $condition) {
    id
    noteID
    tagID
    note {
      id
      title
      trip {
        id
        owner
        tripName
        destination
        startDate
        endDate
        tripImageUrl
        tripImageKey
        notes {
          nextToken
          startedAt
          __typename
        }
        profile {
          id
          owner
          username
          followers
          following
          email
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          __typename
        }
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        profileTripsId
        __typename
      }
      note
      owner
      coords {
        lat
        long
        __typename
      }
      locationName
      createdAt
      images
      tags {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      updatedAt
      _version
      _deleted
      _lastChangedAt
      tripNotesId
      __typename
    }
    tag {
      id
      label
      notes {
        items {
          id
          noteID
          tagID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
          owner
          __typename
        }
        nextToken
        startedAt
        __typename
      }
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    owner
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNoteTagsMutationVariables,
  APITypes.DeleteNoteTagsMutation
>;
